"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function setDeep(object, key, value) {
    const parts = key.split(".");
    const result = copy(object);
    let current = result;
    for (let i = 0; i < parts.length - 1; i++) {
        const index = indexOrKey(current, parts[i]);
        if (current[index] == null) {
            if (/^\d+$/.test(parts[i + 1])) {
                current[index] = [];
            }
            else {
                current[index] = {};
            }
        }
        else {
            current[index] = copy(current[index]);
        }
        current = current[index];
    }
    current[indexOrKey(current, parts[parts.length - 1])] = value;
    return result;
}
exports.default = setDeep;
function copy(objOrArray) {
    return Array.isArray(objOrArray) ? objOrArray.slice() : { ...objOrArray };
}
function indexOrKey(objOrArray, keyOrIndex) {
    return Array.isArray(objOrArray) ? parseInt(keyOrIndex, 10) : keyOrIndex;
}
//# sourceMappingURL=setDeep.js.map